import React, { useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { handleBackFromSrc } from 'fk-cp-common-components/webComponents/V4/app/OrderDetails/V4Helper';
import ContentBlock from 'fk-cp-common-components/webComponents/V4/smartComponents/ContentBlock';
import styles from './CentralWebHeader.css';
import { isFunction } from 'util';
import UAHelper from 'fk-cp-shared/utils/UAHelper';
import IOSNativeCaller from 'fk-cp-shared/components/ios/NativeCaller';
var HeaderContent = function (props) {
    var title = props.title, _a = props.showClose, showClose = _a === void 0 ? false : _a, onBackAction = props.onBackAction, _b = props.isNativeHeaderHidden, isNativeHeaderHidden = _b === void 0 ? false : _b, _c = props.isWebHeaderHidden, isWebHeaderHidden = _c === void 0 ? true : _c, portalDomNode = props.portalDomNode, _d = props.dynamicContents, dynamicContents = _d === void 0 ? {} : _d;
    var hideNativeHeader = !isNativeHeaderHidden || isWebHeaderHidden;
    var handleBackClick = useCallback(function () {
        if (isFunction(onBackAction)) {
            // Dispatch the action instead of calling a function
            onBackAction();
        }
        else {
            // Fallback to default behavior
            handleBackFromSrc(window.location);
        }
    }, [onBackAction, window.location]);
    useEffect(function () {
        var _a, _b;
        if (hideNativeHeader) {
            return;
        }
        if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.Android) === null || _b === void 0 ? void 0 : _b.setHandleBackPress) === 'function') {
            /* Register `onBackPress` before enabling back press handling to avoid a race condition.
            * The native side checks if `setHandleBackPress` is true before calling `onBackPress`.
            */
            window['onBackPress'] = handleBackClick;
            setTimeout(function () {
                window.Android.setHandleBackPress(true);
            }, 0);
        }
        else if (UAHelper._isIOS() && IOSNativeCaller && IOSNativeCaller.bridgeAvailable()) {
            window['onBackPress'] = handleBackClick;
        }
    }, [handleBackClick]);
    if (hideNativeHeader) {
        return null;
    }
    // This is injected from the page level Header widget
    var actionProps = window.__ACTION_PROPS__;
    var header = (<React.Fragment key={window.location.href}>
			<div className={styles.headerContainer}>
				<div className={styles.backButton} onClick={handleBackClick}>	
					{showClose ?
        <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
						<path d="m1.063 1l12.3 12.425m.063-12.362l-12.426 12.3" stroke="#212121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
					</svg>
        : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<g clipPath="url(#clip0_5921_33391)">
							<path d="M20.25 12H3.75" stroke="#333333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M10.5 5.25L3.75 12L10.5 18.75" stroke="#333333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
						</g>
						<defs>
							<clipPath id="clip0_5921_33391">
								<rect width="24" height="24" fill="white"/>
							</clipPath>
						</defs>
					</svg>}
				</div>
				<div className={styles.headerTitle}>{title}</div>
				{Boolean(dynamicContents && dynamicContents.contents && dynamicContents.contents.length > 0) && (<div className={styles.headerContentList}>
						<ContentBlock {...dynamicContents} actionProps={actionProps}/>
					</div>)}
			</div>
			
			<div className={styles.dummyRelativeNew}/>
		</React.Fragment>);
    var portalDomElement = document.getElementById(portalDomNode);
    return portalDomElement ? ReactDOM.createPortal(header, portalDomElement) : header;
};
var mapStateToProps = function (_a) {
    var selfServe = _a.selfServe;
    var _b, _c, _d, _e, _f, _g, _h;
    return ({
        title: (_b = selfServe.headerContent) === null || _b === void 0 ? void 0 : _b.title,
        showClose: (_c = selfServe.headerContent) === null || _c === void 0 ? void 0 : _c.showClose,
        onBackAction: (_d = selfServe.headerContent) === null || _d === void 0 ? void 0 : _d.onBackAction,
        portalDomNode: (_e = selfServe.headerContent) === null || _e === void 0 ? void 0 : _e.portalDomNode,
        isNativeHeaderHidden: (_f = selfServe.headerContent) === null || _f === void 0 ? void 0 : _f.isNativeHeaderHidden,
        isWebHeaderHidden: (_g = selfServe.headerContent) === null || _g === void 0 ? void 0 : _g.isWebHeaderHidden,
        dynamicContents: (_h = selfServe.headerContent) === null || _h === void 0 ? void 0 : _h.dynamicContents
    });
};
export default connect(mapStateToProps)(withRouter(HeaderContent));
